import styled from '@emotion/styled'

export const Container = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  padding: 0;
`

export const Header = styled.div`
  padding: 14px 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  border-bottom: 1px solid #eceff2;
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #1d2025;
  letter-spacing: -0.01em;
`

export const Subtitle = styled.div`
  font-size: 11px;
  color: #6b7280;
`

export const Duo = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px 16px;
`

export const DuoCol = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const MiniLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8a93a0;
`

export const SegmentedGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  background-color: #f1f3f5;
  border-radius: 9px;
  padding: 3px;
`

export const SegmentButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active }) => ($active ? '#1d2025' : '#6b7280')};
  background-color: ${({ $active }) => ($active ? '#ffffff' : 'transparent')};
  box-shadow: ${({ $active }) =>
    $active ? '0 1px 2px rgba(16, 24, 40, 0.1)' : 'none'};
  transition: background-color 0.15s ease, color 0.15s ease;
  &:hover {
    color: #1d2025;
  }
`

export const ColumnsHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 16px 8px;
`

export const ColumnsLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8a93a0;
`

export const Counter = styled.small`
  font-size: 11px;
  color: #98a2b3;
`

export const SearchWrapper = styled.div`
  padding: 0 16px 8px;
`

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 8px 6px;
  max-height: 200px;
  overflow-y: auto;
`

export const Item = styled.li<{ $locked?: boolean; $dragging?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 8px;
  border-radius: 6px;
  user-select: none;
  cursor: ${({ $locked }) => ($locked ? 'default' : 'grab')};
  opacity: ${({ $dragging }) => ($dragging ? 0.5 : 1)};
  &:hover {
    background-color: ${({ $locked }) => ($locked ? 'transparent' : '#f6f7f9')};
  }
`

export const Grip = styled.span<{ $hidden?: boolean }>`
  display: inline-flex;
  width: 14px;
  height: 14px;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`

export const Label = styled.span`
  flex: 1;
  font-size: 13px;
  color: #1d2025;
`

export const Badge = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: #6b7280;
  background-color: #f1f3f5;
  padding: 2px 6px;
  border-radius: 10px;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 4px;
  padding: 12px 16px;
  border-top: 1px solid #eceff2;
  gap: 10px;
`

export const ResetRow = styled.div`
  display: flex;
  justify-content: center;
`

export const ResetLink = styled.button`
  background: none;
  border: none;
  color: #1976d2;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  &:hover {
    text-decoration: underline;
  }
`

export const FooterActions = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;

  & > * {
    flex: 1 1 50%;
  }
`
